import { Link } from 'react-router-dom';
import type { MarketplaceProduct } from '@isbd/shared';
import { MARKETPLACE_PLACEHOLDER_PHOTO } from '@isbd/shared';

function formatPrice(value: number, currency: string) {
  const n = Number(value);
  if (Number.isNaN(n)) return `${value}${currency}`;
  return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}${currency}`;
}

export function ProductCard({ product }: { product: MarketplaceProduct }) {
  const photo = product.photo_urls?.[0] || MARKETPLACE_PLACEHOLDER_PHOTO;
  const currency = product.currency || '€';
  const discount =
    product.old_price && product.old_price > 0
      ? Math.round((1 - Number(product.price) / Number(product.old_price)) * 100)
      : null;

  return (
    <Link to={`/marketplace/${product.id}`} className="mp-card">
      <div className="mp-card-media">
        <img src={photo} alt={product.name} loading="lazy" />
        {product.is_premium ? <span className="mp-card-badge">★ Premium</span> : null}
        {discount && discount > 0 ? <span className="mp-card-sale">-{discount}%</span> : null}
      </div>
      <div className="mp-card-body">
        <div className="mp-card-seller">{product.seller_name}</div>
        <h3 className="mp-card-title">{product.name}</h3>
        {Number(product.rating) > 0 ? (
          <div className="mp-card-rating">
            <span>★</span>
            <span>{product.rating}</span>
          </div>
        ) : null}
        <div className="mp-card-price">
          <strong>{formatPrice(Number(product.price), currency)}</strong>
          {product.old_price ? <s>{formatPrice(Number(product.old_price), currency)}</s> : null}
        </div>
        <div className="mp-card-more">En savoir plus →</div>
      </div>
    </Link>
  );
}
